'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Switch } from 'react-router-dom';
import TrackedRoute from 'AdsUI/lib/TrackedRoute';
import TrackedRedirect from 'AdsUI/lib/TrackedRedirect';
import Application from 'AdsUI/components/Application';
import makeLoadable from 'AdsUI/lib/makeLoadable';
import CampaignListPageContainer from 'AdsUI/containers/campaigns/CampaignListPageContainer';
import CampaignDetailsContainer from 'AdsUI/containers/campaign-details/CampaignDetailsContainer';
import CampaignListManagementPanelContainer from 'AdsUI/containers/campaign-details/CampaignListManagementPanelContainer';
import DraftsContainer from 'AdsUI/containers/campaigns/DraftsContainer';
import GoalsContainer from 'AdsUI/containers/goals/GoalsContainer';
import OnboardingEmptyState from 'AdsUI/components/onboarding/EmptyState'; // Analyze tab

const AnalyzeDashboardLoader = makeLoadable(() => import('AdsUI/components/AnalyzeDashboard')); // Recommendations tab

const RecommendationsContainerLoader = makeLoadable(() => import('AdsUI/containers/recommendations/RecommendationsContainer'));
const AdWordsAdvancedSettingsContainerLoader = makeLoadable(() => import('AdsUI/components/AdvancedSettingsContainer')); // Audiences

const AudiencesContainerLoader = makeLoadable(() => import('AdsUI/containers/audiences/AudiencesContainer'));
const AudiencePanelContainerLoader = makeLoadable(() => import('AdsUI/containers/audiences/AudiencePanelContainer')); // Onboarding

const OnboardingWizardContainerLoader = makeLoadable(() => import('AdsUI/containers/onboarding/OnboardingWizardContainer')); // Events

const EventsContainerLoader = makeLoadable(() => import('AdsUI/containers/events/EventsContainer')); // Ad Creation

const AdCreationContainerLoader = makeLoadable(() => import('AdsUI/containers/creation/AdCreationContainer'));
const AdCreationWelcomeContainerLoader = makeLoadable(() => import('AdsUI/containers/creation/AdCreationWelcomeContainer')); // Ad Editing

const AdEditContainerLoader = makeLoadable(() => import(
/* webpackChunkName: "ad-editing" */
'AdsUI/containers/editing/AdEditContainer')); // Sequences

const SequencesContainerLoader = makeLoadable(() => import('AdsUI/containers/campaigns/SequencesContainer'));
const AdCreationSequenceContainerLoader = makeLoadable(() => import('AdsUI/containers/creation/sequence/AdCreationSequenceContainer'));
const SequenceDetailsContainerLoader = makeLoadable(() => import('AdsUI/containers/sequence-details/SequenceDetailsContainer'));
export default /*#__PURE__*/_jsx(Application, {
  children: /*#__PURE__*/_jsxs(Switch, {
    children: [/*#__PURE__*/_jsx(TrackedRoute, {
      path: "/",
      component: CampaignListPageContainer,
      name: "campaigns-list",
      exact: true
    }), /*#__PURE__*/_jsx(TrackedRoute, {
      path: "/manage/:network/:accountId/campaigns/:campaignId",
      name: "campaign-enhanced-editor",
      children: /*#__PURE__*/_jsx(CampaignListPageContainer, {
        children: /*#__PURE__*/_jsx(CampaignListManagementPanelContainer, {})
      })
    }), /*#__PURE__*/_jsx(TrackedRoute, {
      path: "/drafts",
      component: DraftsContainer,
      name: "drafts"
    }), /*#__PURE__*/_jsx(TrackedRoute, {
      path: "/sequences/:sequenceId",
      component: SequenceDetailsContainerLoader,
      name: "sequence"
    }), /*#__PURE__*/_jsx(TrackedRoute, {
      path: "/sequences",
      component: SequencesContainerLoader,
      name: "sequences",
      exact: true
    }), /*#__PURE__*/_jsx(TrackedRoute, {
      path: "/onboarding-wizard",
      component: OnboardingWizardContainerLoader,
      name: "onboarding-wizard",
      exact: true
    }), /*#__PURE__*/_jsx(TrackedRoute, {
      path: "/onboarding-wizard/:step",
      component: OnboardingWizardContainerLoader,
      name: "onboarding-wizard",
      exact: true
    }), /*#__PURE__*/_jsx(TrackedRoute, {
      path: "/audiences",
      name: "audiences",
      children: /*#__PURE__*/_jsx(AudiencesContainerLoader, {
        children: /*#__PURE__*/_jsx(TrackedRoute, {
          path: "/audiences/:audienceId",
          component: AudiencePanelContainerLoader,
          name: "audience-details-panel",
          exact: true
        })
      })
    }), /*#__PURE__*/_jsx(TrackedRoute, {
      path: "/events",
      component: EventsContainerLoader,
      name: "events",
      exact: true
    }), /*#__PURE__*/_jsx(TrackedRoute, {
      path: "/events/:eventId",
      name: "event-details-panel",
      component: EventsContainerLoader,
      exact: true
    }), /*#__PURE__*/_jsx(TrackedRoute, {
      path: "/onboarding",
      component: OnboardingEmptyState,
      name: "onboarding",
      exact: true
    }), /*#__PURE__*/_jsx(TrackedRoute, {
      path: "/advanced-settings",
      name: "rmf-advanced-settings",
      component: AdWordsAdvancedSettingsContainerLoader
    }), /*#__PURE__*/_jsx(TrackedRoute, {
      path: "/accounts/:network/:accountId/campaigns/:campaignId",
      component: CampaignDetailsContainer,
      name: "campaign-details"
    }), /*#__PURE__*/_jsx(TrackedRoute, {
      path: "/campaigns/new",
      name: "ad-creation-welcome",
      component: AdCreationWelcomeContainerLoader,
      exact: true
    }), /*#__PURE__*/_jsx(TrackedRoute, {
      path: "/campaigns/new/:type/:network",
      name: "ad-creation-welcome",
      component: AdCreationWelcomeContainerLoader,
      exact: true
    }), /*#__PURE__*/_jsx(TrackedRoute, {
      path: "/campaigns/new/:type",
      name: "ad-creation-welcome",
      component: AdCreationWelcomeContainerLoader,
      exact: true
    }), /*#__PURE__*/_jsx(TrackedRoute, {
      path: "/campaigns/:network/sequence/new",
      name: "sequence-ad-creation",
      component: AdCreationSequenceContainerLoader,
      exact: true
    }), /*#__PURE__*/_jsx(TrackedRoute, {
      path: "/campaigns/:network/sequence/new/:sequenceStep/",
      name: "sequence-ad-creation",
      component: AdCreationSequenceContainerLoader,
      exact: true
    }), /*#__PURE__*/_jsx(TrackedRoute, {
      path: "/campaigns/:network/sequence/new/:sequenceStep/:creationStep",
      name: "sequence-ad-creation",
      component: AdCreationSequenceContainerLoader,
      exact: true
    }), /*#__PURE__*/_jsx(TrackedRoute, {
      path: "/campaigns/:network/sequence/drafts/:draftId",
      name: "sequence-ad-creation",
      component: AdCreationSequenceContainerLoader,
      exact: true
    }), /*#__PURE__*/_jsx(TrackedRoute, {
      path: "/campaigns/:network/sequence/drafts/:draftId/:sequenceStep",
      name: "sequence-ad-creation",
      component: AdCreationSequenceContainerLoader,
      exact: true
    }), /*#__PURE__*/_jsx(TrackedRoute, {
      path: "/campaigns/:network/sequence/drafts/:draftId/:sequenceStep/:creationStep",
      name: "sequence-ad-creation",
      component: AdCreationSequenceContainerLoader,
      exact: true
    }), /*#__PURE__*/_jsx(TrackedRoute, {
      path: "/campaigns/:network/sequence/edit/:sequenceId/:sequenceStep",
      name: "sequence-ad-edit",
      component: AdCreationSequenceContainerLoader,
      exact: true
    }), /*#__PURE__*/_jsx(TrackedRoute, {
      path: "/campaigns/:network/:type/new",
      name: "lead-ad-creation",
      component: AdCreationContainerLoader,
      exact: true
    }), /*#__PURE__*/_jsx(TrackedRoute, {
      path: "/campaigns/:network/:type/new/:step",
      name: "lead-ad-creation",
      component: AdCreationContainerLoader,
      exact: true
    }), /*#__PURE__*/_jsx(TrackedRoute, {
      path: "/campaigns/:network/:type/new/:step/:creativeIndex",
      name: "lead-ad-creation",
      component: AdCreationContainerLoader,
      exact: true
    }), /*#__PURE__*/_jsx(TrackedRoute, {
      path: "/campaigns/:network/:type/drafts/:draftId",
      name: "lead-ad-creation",
      component: AdCreationContainerLoader,
      exact: true
    }), /*#__PURE__*/_jsx(TrackedRoute, {
      path: "/campaigns/:network/:type/drafts/:draftId/:step",
      name: "lead-ad-creation",
      component: AdCreationContainerLoader,
      exact: true
    }), /*#__PURE__*/_jsx(TrackedRoute, {
      path: "/campaigns/:network/:type/drafts/:draftId/:step/:creativeIndex",
      name: "lead-ad-creation",
      component: AdCreationContainerLoader,
      exact: true
    }), /*#__PURE__*/_jsx(TrackedRoute, {
      path: "/:network/:accountId/campaigns/:campaignId/edit/:step",
      name: "ad-campaign-editing",
      component: AdEditContainerLoader,
      exact: true
    }), /*#__PURE__*/_jsx(TrackedRoute, {
      path: "/:network/:accountId/campaigns/:campaignId/adgroups/:adGroupId/edit/:step",
      name: "ad-campaign-editing",
      component: AdEditContainerLoader,
      exact: true
    }), /*#__PURE__*/_jsx(TrackedRoute, {
      path: "/:network/:accountId/campaigns/:campaignId/adgroups/:adGroupId/ad/:adId/edit/:step",
      name: "ad-campaign-editing",
      component: AdEditContainerLoader,
      exact: true
    }), /*#__PURE__*/_jsx(TrackedRoute, {
      path: "/dashboard",
      name: "analyze-dashboard",
      component: AnalyzeDashboardLoader
    }), /*#__PURE__*/_jsx(TrackedRoute, {
      path: "/goals",
      name: "goals",
      component: GoalsContainer
    }), /*#__PURE__*/_jsx(TrackedRoute, {
      path: "/recommendations",
      name: "recommendations",
      component: RecommendationsContainerLoader
    }), /*#__PURE__*/_jsx(TrackedRedirect, {
      from: "/campaigns/facebook",
      to: "/",
      name: "legacy-facebook-details-page-list"
    }), /*#__PURE__*/_jsx(TrackedRedirect, {
      from: "/campaigns/facebook/:campaignId",
      to: "/",
      name: "legacy-facebook-details-page"
    }), /*#__PURE__*/_jsx(TrackedRedirect, {
      from: "/campaigns/adwords",
      to: "/",
      name: "legacy-adwords-details-page-list"
    }), /*#__PURE__*/_jsx(TrackedRedirect, {
      from: "/campaigns/adwords/:campaignId",
      to: "/",
      name: "legacy-adwords-details-page"
    }), /*#__PURE__*/_jsx(TrackedRedirect, {
      from: "/campaigns/adwords/:campaignId/settings",
      to: "/",
      name: "legacy-adwords-details-page-edit"
    }), /*#__PURE__*/_jsx(TrackedRedirect, {
      from: "/create-facebook-lead-ad-campaign",
      to: "/campaigns/facebook/lead-generation/new",
      name: "legacy-facebook-lead-ad-creation"
    })]
  })
});